export const environment = {
  production: true,
  BASE_DOMAIN:'https://fms-dev.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://fms-dev.apollosupplychain.com/',
  AUTH_URL:'https://auth-dev.apollosupplychain.com/auth-service-common/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://fms-dev.apollosupplychain.com/',
  WebsocketUrl: 'wss://fms-dev.apollosupplychain.com/websocket-service/ws/notifications'
};
